module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/*Site page site closed */
(function(fox) {

	fox.registerWidget('SitePage_SiteClosed', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					loginForm: {
						widget: 'User_Login',
						useCaptcha: true,
						reloadCaptchaOnError: true,
						captchaAlias: 'autumnNew',
						container: '#autorization-container',
						template: 'stateoff_user_login',
						autoRender: true,
						active: true,
						group: 'form',
						handleDom: {
							handleFocus: {
								event: 'focus',
								target: '[name]',
								callback: function (el) {
									var el = $(el);

									el.parent().removeClass('error').next().text('').removeClass('show');
									$('#loginFormError').hide();
									this.hideDefaultErrorBlock();
								}
							},
							reloadCapcha: {
								targetWidget: '#captcha',
								target: '#reload_captcha',
								event: 'click',
								callback: function () {
									this.wom1('#captcha').loadCaptcha()
								}
							}
						},
						handleWom: {
							loginError: {
								event: 'loginError',
								widget: '@root',
								callback: function(response) {
									//$('#loginFormError').show();
									var alias = null;
									var txt = response.reason;
									var code = response.code;
									var container = $(this.element[0]);
									var inp;
									var erase = false;

									if (code == 2001 || code == 43) {
										alias = 'le';
									}

									if (code == 3) {
										alias = 'captcha';
										erase = true;
									}

									if (code == 4 || code == 44) {
										alias = 'password';
										erase = true;
									}

									if (code == 2 || code == 6) {
										//$('#loginFormError').show();
										this.showDefaultErrorBlock();
										this.hideErrorBlock();

										return;
									}

									input = container.find('[name="le"]')

									if (erase) {
										input.val('')
									} 
									
									input.parent().addClass('error').next().text(txt).addClass('show');
									this.hideDefaultErrorBlock();
								}
							}
						}
					},
					socialAppsBlock: {
						widget: 'Stateoff_SocialApps_Block'
					}
				}
			})
		
			this.callParent('configure', arguments);
		}

	}, 'Site_Page');
	
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/siteClosed.js
// module id = 932
// module chunks = 4